// // function Products() {

// //   const dairyProducts = [
// //     "Milk",
// //     "Curd Light",
// //     "Curd Magic",
// //     "Paneer Chakka",
// //     "Paneer Tikka",
// //     "Paneer Malai",
// //     "Mawa",
// //     "Dhaap",
// //     "Khoya",
// //     "Bread",
// //     "Eggs",
// //     "Green Peas",
// //     "Sweet Corn",
// //     "Noodles",
// //     "Maharaja Soya Chaap",
// //     "Soya Chaap"
// //   ];

// //   const importedCheese = [
// //     "Grana Padano",
// //     "Emmenthal Cheese Block",
// //     "Goat Log Natural",
// //     "Edam Ball Mild",
// //     "Gouda Mild",
// //     "Danish Blue",
// //     "White Cheese (Feta)",
// //     "Gruyere Cheese",
// //     "Cheddar Mild White",
// //     "Cheddar Mild Yellow",
// //     "Monterey Jack",
// //     "Brie Cheese",
// //     "Camembert Cheese"
// //   ];

// //   const frozenVeg = [
// //     "Filo Pastry",
// //     "TYJ Spring Roll Sheets",
// //     "Green Peas Frozen",
// //     "Sweet Corn Frozen",
// //     "French Fries 9mm Premium",
// //     "Potato Super Wedges",
// //     "Samosa Patti",
// //     "Spring Roll Sheets 7.5 inch",
// //     "Spring Roll Sheets 8 inch"
// //   ];

// //   const frozenCreams = [
// //     "Rich Cooking Cream",
// //     "Rich Whipping Cream"
// //   ];

// //   const mozzarellaRange = [
// //     "Mozzarella Block Frozen",
// //     "Diced Mozzarella Cheese",
// //     "Diced Blend Pizza Cheese",
// //     "Milky Mist Pizza Cheese",
// //     "Burrata Cheese",
// //     "Mascarpone Cheese",
// //     "Ricotta Cheese",
// //     "Bocconcini Cheese",
// //     "Smoked Scamorza Cheese",
// //     "Sour Cream Cheese",
// //     "Cream Cheese",
// //     "Cheese Slice"
// //   ];

// //   const frozenMeat = [
// //     "Pork Belly Skin On",
// //     "Pork Belly Skinless",
// //     "Pork Spare Rib",
// //     "Pork Loin Ribs",
// //     "Pork Neck Boneless",
// //     "Pork Chops",
// //     "Whole Duck Without Neck",
// //     "Lamb Rack Cap Off"
// //   ];

// //   const seafood = [
// //     "Salmon Fillet",
// //     "Smoked Salmon",
// //     "Basa Fish Fillet",
// //     "Prawns 8/12",
// //     "Prawns 13/15",
// //     "Prawns 16/20",
// //     "Prawns 21/25",
// //     "Prawns 26/30",
// //     "Prawns 31/40",
// //     "Prawns 41/50"
// //   ];

// //   const indianMeat = [
// //     "Bacon Slice",
// //     "Chicken Ham Slice",
// //     "Chicken Sausages",
// //     "Chicken Salami Slice",
// //     "Pork Ham",
// //     "Pork Pizza Pepperoni",
// //     "Smoked Chicken Breast",
// //     "Chicken Burger Patty",
// //     "Chicken Finger",
// //     "Chicken Fries",
// //     "Chicken Nuggets",
// //     "Chicken Seekh Kebab",
// //     "Chicken Seekh Kebab Hot & Spicy",
// //     "Chicken Tandoori Tikka",
// //     "Pork Sausages",
// //     "Chicken Jumbo Hotdog",
// //     "Chicken Pepperoni Slice"
// //   ];

// //   const porkSausages = [
// //     "Pork Frankfurter Sausage",
// //     "Pork Nuremberger Sausage",
// //     "Pork Garlic Krakauer Sausage",
// //     "Pork Curlies Sausage",
// //     "Pork Bratwurst Sausage",
// //     "Pork Bockwurst Sausage",
// //     "Pork Cocktail Sausage",
// //     "Pork Bratwurst With Bacon",
// //     "Pork Weisswurst Sausage",
// //     "Pork Cheese Sausage",
// //     "Pork Spicy Sausage",
// //     "Pork Bacon Sausage",
// //     "Pork Currywurst Sausage",
// //     "Pork Bavarian Meatloaf",
// //     "Pork Meatloaf With Black Pepper",
// //     "Pork Cold Cut Lyoner",
// //     "Pork Cold Cut With Red Paprika"
// //   ];

// //   const chickenSausages = [
// //     "Chicken Sausage Plain",
// //     "Chicken Frankfurter",
// //     "Chicken Bratwurst",
// //     "Chicken Nuremberger",
// //     "Chicken Krakauer",
// //     "Chicken Hotdog Smoked",
// //     "Chicken Cheese Cocktail",
// //     "Chicken Sausage With Chilli",
// //     "Chicken Cheese & Onion",
// //     "Chicken Cheese & Chilli",
// //     "Chicken Cold Cut Lyoner",
// //     "Chicken Cold Cut With Red Paprika",
// //     "Chicken Cold Cut With Red Chilli",
// //     "Chicken Jalapeno & Cheese",
// //     "Chicken Cocktail Sausage",
// //     "Chicken Tikka Sausage",
// //     "Chicken Krainer Sausage",
// //     "Chicken Knackwurst",
// //     "Chicken Sausage With Chives",
// //     "Chicken Meatloaf"
// //   ];

// //   const renderSection = (title, items) => (
// //     <>
// //       <h2 style={{ marginTop: "80px" }}>{title}</h2>
// //       <div className="grid">
// //         {items.map((item, index) => (
// //           <div className="card" key={index}>
// //             <div className="card-content">
// //               <h3>{item}</h3>
// //               <p>Bulk & Wholesale Supply Available</p>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </>
// //   );

// //   return (
// //     <div className="section">
// //       <h2>Our Product Range</h2>

// //       {renderSection("Dairy Products", dairyProducts)}
// //       {renderSection("Imported Cheeses", importedCheese)}
// //       {renderSection("Frozen Veg & Sheets", frozenVeg)}
// //       {renderSection("Frozen Creams", frozenCreams)}
// //       {renderSection("Mozzarella & Premium Cheese Range", mozzarellaRange)}
// //       {renderSection("Frozen Meat Products", frozenMeat)}
// //       {renderSection("Seafood Range", seafood)}
// //       {renderSection("Indian Meat Products", indianMeat)}
// //       {renderSection("Pork Sausages", porkSausages)}
// //       {renderSection("Chicken Sausages", chickenSausages)}

// //     </div>
// //   );
// // }

// // export default Products;

// import milk from "../assets/milk.png";
// import paneerTikka from "../assets/Paneer-Tikka.png";
// import paneer from "../assets/Paneer.png";
// import bread from "../assets/Bread.png";
// import curd from "../assets/curd.png";
// import greenPeas from "../assets/Greenpeas.png";
// import corn from "../assets/Corn.png";
// import egg from "../assets/Egg.png";
// import khoya from "../assets/KhoyaMawa.png";
// import dhap from "../assets/Dhapmawa.png";
// import noodles from "../assets/noodles.png";
// import chap from "../assets/Soyachaap.png";

// function Products() {

//   const dairyProducts = [
//     { name: "Milk", image: milk },
//     { name: "Curd Light", image: curd },
//     { name: "Curd Magic", image: curd },
//     { name: "Paneer Chakka", image: paneer },
//     { name: "Paneer Tikka", image: paneerTikka },
//     { name: "Paneer Malai", image: paneer },
//     { name: "Mawa", image: khoya },
//     { name: "Dhaap", image: dhap },
//     { name: "Khoya", image: khoya },
//     { name: "Bread", image: bread },
//     { name: "Eggs", image: egg },
//     { name: "Green Peas", image: greenPeas },
//     { name: "Sweet Corn", image: corn },
//     { name: "Noodles" ,image:noodles},
//     { name: "Soya Chaap", image:chap },
//     // { name: "Soya Chaap" }
//   ];

//   const renderSection = (title, items) => (
//     <>
//       <h2 style={{ marginTop: "80px" }}>{title}</h2>
//       <div className="grid">
//         {items.map((item, index) => (
//           <div className="card" key={index}>

//             {item.image && (
//               <img
//                 src={item.image}
//                 alt={item.name}
//                 className="product-image"
//               />
//             )}

//             <div className="card-content">
//               <h3>{item.name}</h3>
//               <p>Bulk & Wholesale Supply Available</p>
//             </div>

//           </div>
//         ))}
//       </div>
//     </>
//   );

//   return (
//     <div className="section">
//       <h2>Our Product Range</h2>
//       {renderSection("Dairy Products", dairyProducts)}
//     </div>
//   );
// }

// export default Products;
import milk from "../assets/milk.png";
import paneerTikka from "../assets/Paneer-Tikka.png";
import paneer from "../assets/Paneer.png";
import bread from "../assets/Bread.png";
import curd from "../assets/curd.png";
import greenPeas from "../assets/Greenpeas.png";
import corn from "../assets/Corn.png";
import egg from "../assets/Egg.png";
import khoya from "../assets/KhoyaMawa.png";
import dhap from "../assets/Dhapmawa.png";
import noodles from "../assets/noodles.png";
import chap from "../assets/Soyachaap.png";

function Products() {

  const dairyProducts = [
    { name: "Milk", image: milk },
    { name: "Curd Light", image: curd },
    { name: "Curd Magic", image: curd },
    { name: "Paneer Chakka", image: paneer },
    { name: "Paneer Tikka", image: paneerTikka },
    { name: "Paneer Malai", image: paneer },
    // { name: "All Amul Products" },
    { name: "Noodle", image: noodles },
    // { name: "Maharaja Soya Chaap" },
    { name: "Soya Chaap", image: chap },
    { name: "Bread", image: bread },
    { name: "Egg", image: egg },
    { name: "Green Peas", image: greenPeas },
    { name: "Sweet Corn", image: corn },
    { name: "Mawa", image: khoya },
    { name: "Dhaap", image: dhap },
    { name: "Khoya", image: khoya }
  ];

  const importedCheese = [
    { name: "Grana Padano" },
    { name: "Emmenthal Cheese Block" },
    { name: "Goat Log Natural" },
    { name: "Edam Ball Mild" },
    { name: "Gouda Mild" },
    { name: "Danish Blue" },
    { name: "White Cheese (Feta)" },
    { name: "Gruyere Cheese" },
    { name: "Cheddar Mild White" },
    { name: "Cheddar Mild Yellow" },
    { name: "Monterey Jack" },
    { name: "Brie Cheese" },
    { name: "Camembert Cheese" }
  ];

  const frozenVegSheets = [
    { name: "Filo Pastry" },
    { name: "TYJ Spring Roll Sheets 7.5 inch" },
    { name: "Samosa Patti" },
    { name: "Spring Roll Sheets 7.5 inch" },
    { name: "Spring Roll Sheets 8 inch" },
    { name: "French Fries 9mm Premium" },
    { name: "Potato Super Wedges" }
  ];

  const frozenCreams = [
    { name: "Rich Cooking Cream" },
    { name: "Rich Whipping Cream" }
  ];

  const mozzarellaRange = [
    { name: "Mozzarella Block Frozen" },
    { name: "Diced Mozzarella Cheese Frozen" },
    { name: "Diced Blend Pizza Cheese Frozen" },
    { name: "Milky Mist Pizza Cheese" },
    { name: "Burrata Cheese" },
    { name: "Mascarpone Cheese" },
    { name: "Ricotta Cheese" },
    { name: "Bocconcini Cheese" },
    { name: "Smoked Scamorza Cheese" },
    { name: "Sour Cream Cheese" },
    { name: "Cream Cheese" },
    { name: "Cheese Slice 765g" }
  ];

  const frozenMeat = [
    { name: "Pork Belly Skin On" },
    { name: "Pork Belly Skinless" },
    { name: "Pork Spare Rib" },
    { name: "Pork Loin Ribs" },
    { name: "Pork Neck Boneless" },
    { name: "Pork Chops" },
    { name: "Whole Duck Without Neck" },
    { name: "Lamb Rack Cap Off" }
  ];

  const seafood = [
    { name: "Salmon Fillet Fresh" },
    { name: "Smoked Salmon Fish" },
    { name: "Basa Fish Fillet" },
    { name: "Prawns 8/12 (PDTO)" },
    { name: "Prawns 13/15 (PDTO)" },
    { name: "Prawns 16/20 (PDTO)" },
    { name: "Prawns 21/25 (PDTO)" },
    { name: "Prawns 26/30 (PDTO)" },
    { name: "Prawns 31/40 (PDTO)" },
    { name: "Prawns 41/50 (PDTO)" }
  ];

  const indianMeat = [
    { name: "Bacon Slice" },
    { name: "Chicken Ham Slice" },
    { name: "Chicken Sausages" },
    { name: "Chicken Salami Slice" },
    { name: "Pork Ham" },
    { name: "Pork Pizza Pepperoni" },
    { name: "Smoked Chicken Breast" },
    { name: "Chicken Burger Patty" },
    { name: "Chicken Finger" },
    { name: "Chicken Fries" },
    { name: "Chicken Nuggets" },
    { name: "Chicken Seekh Kebab" },
    { name: "Chicken Seekh Kebab Hot & Spicy" },
    { name: "Chicken Tandoori Tikka" },
    { name: "Pork Sausages" },
    { name: "Chicken Jumbo Hotdog" },
    { name: "Chicken Pepperoni Slice" }
  ];

  const porkSausages = [
    { name: "Pork Frankfurter Sausage" },
    { name: "Pork Nuremberger Sausage" },
    { name: "Pork Garlic Krakauer Sausage" },
    { name: "Pork Curlies Sausage" },
    { name: "Pork Bratwurst Sausage" },
    { name: "Pork Bockwurst Sausage" },
    { name: "Pork Cocktail Sausage" },
    { name: "Pork Bratwurst With Bacon" },
    { name: "Pork Weisswurst Sausage" },
    { name: "Pork Cheese Sausage" },
    { name: "Pork Spicy Sausage" },
    { name: "Pork Bacon Sausage" },
    { name: "Pork Currywurst Sausage" },
    { name: "Pork Bavarian Meatloaf" },
    { name: "Pork Meatloaf With Black Pepper" },
    { name: "Pork Cold Cut Lyoner" },
    { name: "Pork Cold Cut With Red Paprika" }
  ];

  const chickenSausages = [
    { name: "Chicken Sausage Plain" },
    { name: "Chicken Frankfurter" },
    { name: "Chicken Bratwurst" },
    { name: "Chicken Nuremberger" },
    { name: "Chicken Krakauer" },
    { name: "Chicken Hotdog Smoked" },
    { name: "Chicken Cheese Cocktail" },
    { name: "Chicken Sausage With Chilli" },
    { name: "Chicken Cheese & Onion" },
    { name: "Chicken Cheese & Chilli" },
    { name: "Chicken Cold Cut Lyoner" },
    { name: "Chicken Cold Cut With Red Paprika" },
    { name: "Chicken Cold Cut With Red Chilli" },
    { name: "Chicken Jalapeno & Cheese" },
    { name: "Chicken Cocktail Sausage" },
    { name: "Chicken Tikka Sausage" },
    { name: "Chicken Krainer Sausage" },
    { name: "Chicken Knackwurst" },
    { name: "Chicken Sausage With Chives" },
    { name: "Chicken Meatloaf" }
  ];

  const renderSection = (title, items) => (
    <>
      <h2 style={{ marginTop: "80px" }}>{title}</h2>
      <div className="grid">
        {items.map((item, index) => (
          <div className="card" key={index}>
            {item.image && (
              <img
                src={item.image}
                alt={item.name}
                className="product-image"
              />
            )}
            <div className="card-content">
              <h3>{item.name}</h3>
              <p>Bulk & Wholesale Supply Available</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className="section">
      <h2>Our Product Range</h2>

      {renderSection("Dairy Products", dairyProducts)}
      {renderSection("Imported Cheeses", importedCheese)}
      {renderSection("Frozen Veg & Sheets", frozenVegSheets)}
      {renderSection("Frozen Creams", frozenCreams)}
      {renderSection("Mozzarella & Premium Cheese Range", mozzarellaRange)}
      {renderSection("Frozen Meat Products", frozenMeat)}
      {renderSection("Seafood Range", seafood)}
      {renderSection("Indian Meat Products", indianMeat)}
      {renderSection("Pork Sausages", porkSausages)}
      {renderSection("Chicken Sausages", chickenSausages)}

    </div>
  );
}

export default Products;